import Factory from "./factory"

export type * from "./types"
export type { Header, Options, Table, Formatter } from "./factory"

export default Factory
